import { useState, useCallback } from 'react';
import { t } from '@lingui/macro';

const useInput = ({
    hasFilterApplied,
    defaultPlaceholder = t`Search instruments, genres, keyword...`,
}: {
    hasFilterApplied: boolean;
    defaultPlaceholder?: string;
}) => {
    const [inputValue, setInputValue] = useState('');

    const placeholder = hasFilterApplied ? t`Add more` : defaultPlaceholder;

    const onInputChange = (value: string): void => {
        setInputValue(value);
    };

    const clearTextInput = useCallback(() => {
        setInputValue('');
    }, [setInputValue]);

    return {
        placeholder,
        inputValue,
        onInputChange,
        clearTextInput,
        hasTextInputValue: !!inputValue,
    };
};

export default useInput;
